import React from "react";
import styles from "./OfferRow.module.css";
import { useHistory } from "react-router-dom";

import type {
  AdminOffer,
} from "../../../../slices/adminOffer/adminOfferSlice";


interface OfferRowProps {
  offer: AdminOffer;
}

const OfferRow: React.FC<OfferRowProps> = ({
  offer,
}) => {
  const history = useHistory();

  const formatDate = (
    date: string | null
  ) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString(
      "pl-PL"
    );
  };

  const getOfferStatus = () => {
    if (!offer.isActive) {
      return "Nieaktywna";
    }

    if (!offer.expirationDate) {
      return "Aktywna";
    }

    const now = new Date();

    const expiration = new Date(
      offer.expirationDate
    );

    if (expiration.getTime() < now.getTime()) {
      return "Przedawniona";
    }

    const difference =
      expiration.getTime() - now.getTime();

    const daysLeft = Math.ceil(
      difference / (1000 * 60 * 60 * 24)
    );

    if (daysLeft <= 30) {
      return "Wygasa wkrótce";
    }

    return "Aktywna";
  };

  return (
    <div
      className={styles.Row}
      onClick={() => history.push(`/admin/offers/${offer._id}`)}
    >
      <div className={styles.Company}>
        <div className={styles.Name}>
          {offer.name}
        </div>

        <div className={styles.Nip}>
          NIP: {offer.NIP}
        </div>
      </div>

      <div className={styles.Owner}>
        <span className={styles.MobileLabel}>
          Właściciel:
        </span>

        {offer.user || "-"}
      </div>

      <div className={styles.Assignment}>
        <span className={styles.MobileLabel}>
          Przypisanie:
        </span>

        {offer.isAssigned
          ? "Przypisana"
          : "Nieprzypisana"}
      </div>

      <div className={styles.Expiration}>
        <span className={styles.MobileLabel}>
          Ważna do:
        </span>

        {formatDate(offer.expirationDate)}
      </div>

      <div className={styles.Status}>
        <span className={styles.MobileLabel}>
          Status:
        </span>

        {getOfferStatus()}
      </div>
    </div>
  );
};

export default OfferRow;